import {
  CAT_RUNNING_CHARACTER_KEY,
  CAT_RUNNING_GROUND_Y,
  CAT_RUNNING_INITIAL_SPEED,
  CAT_RUNNING_PLAYER_HEIGHT,
  CAT_RUNNING_PLAYER_WIDTH,
  CAT_RUNNING_PLAYER_X,
  CAT_RUNNING_REVIVE_GRACE_MS,
  CAT_RUNNING_STAGE_KEY,
} from '../constants'
import { createSeededRandom } from './random'
import { getRandomChuruSpawnMsWith } from './spawners/churus'
import { getRandomObstacleSpawnMsWith } from './spawners/obstacles'

export const createInitialPlayerState = () => ({
  x: CAT_RUNNING_PLAYER_X,
  y: CAT_RUNNING_GROUND_Y,
  previousY: CAT_RUNNING_GROUND_Y,
  width: CAT_RUNNING_PLAYER_WIDTH,
  height: CAT_RUNNING_PLAYER_HEIGHT,
  velocityY: 0,
  isGrounded: true,
  frameIndex: 0,
})

const createSpawnTimers = (randomFn) => ({
  obstacleMs: getRandomObstacleSpawnMsWith(randomFn),
  churuMs: getRandomChuruSpawnMsWith(randomFn),
})

export const createInitialWorldState = (options = {}) => {
  const spawnManifest = options.spawnManifest ?? null
  const runSeed = options.runSeed ?? spawnManifest?.runSeed ?? Date.now()
  const randomFn = createSeededRandom(runSeed)

  return {
    status: 'running',
    elapsedMs: 0,
    distance: 0,
    churuCount: 0,
    stageKey: CAT_RUNNING_STAGE_KEY,
    selectedCharacterKey: CAT_RUNNING_CHARACTER_KEY,
    speed: CAT_RUNNING_INITIAL_SPEED,
    backgroundOffset: 0,
    previousBackgroundOffset: 0,
    reviveUsed: false,
    reviveDistance: 0,
    invincibleMs: 0,
    magnetMs: 0,
    reviveGraceMs: 0,
    runSeed,
    randomFn,
    spawnManifest,
    maxRunSec: Number(spawnManifest?.maxRunSec) || null,
    startWarmupM: Number(spawnManifest?.startWarmupM) || null,
    continueWarmupM: Number(spawnManifest?.continueWarmupM) || null,
    frameReplay: Array.isArray(options.frameReplay) ? options.frameReplay : null,
    frameReplayCursor: 0,
    frameReplayDurationSec:
      options.frameReplayDurationSec ??
      (Array.isArray(options.frameReplay) && options.frameReplay.length
        ? options.frameReplay[options.frameReplay.length - 1].t
        : 0),
    nextScriptedChuruIndex: 0,
    player: createInitialPlayerState(),
    obstacles: [],
    churus: [],
    spawnTimers: createSpawnTimers(randomFn),
    obstacleSpawnState: {
      previousIndex: -1,
      streak: 0,
    },
  }
}

export const reviveWorldState = (world) => {
  world.status = 'running'
  world.reviveUsed = true
  world.reviveDistance = Math.floor(world.distance)
  world.invincibleMs = 0
  world.magnetMs = 0
  world.reviveGraceMs = CAT_RUNNING_REVIVE_GRACE_MS
  world.player = createInitialPlayerState()
  world.randomFn = createSeededRandom(world.runSeed)
  const scriptedSpawns = world.spawnManifest?.churuSpawns
  world.nextScriptedChuruIndex = Array.isArray(scriptedSpawns)
    ? scriptedSpawns.findIndex((spawn) => Number(spawn?.tSec) > world.elapsedMs / 1000)
    : 0
  if (world.nextScriptedChuruIndex < 0) {
    world.nextScriptedChuruIndex = Array.isArray(scriptedSpawns) ? scriptedSpawns.length : 0
  }
  world.spawnTimers = createSpawnTimers(world.randomFn)
  world.obstacleSpawnState = {
    previousIndex: -1,
    streak: 0,
  }
}

export const buildHudState = (world) => ({
  gameStatus: world.status,
  distance: Math.floor(world.distance),
  churuCount: world.churuCount,
  stageKey: world.stageKey,
  selectedCharacterKey: world.selectedCharacterKey,
  reviveUsed: world.reviveUsed,
  invincibleMs: world.invincibleMs,
  magnetMs: world.magnetMs,
})
